import { render } from "./banners-list.html?vue&type=template&id=fba3a830&ts=true"
import script from "./banners-list.vue?vue&type=script&lang=ts"
export * from "./banners-list.vue?vue&type=script&lang=ts"

import "./banners-list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__